//import logo from './logo.svg';
//import './App.css';
import React, {useEffect,useState} from 'react';


import ReactDOM from 'react-dom'
//import {Container, AppBar, Typography, Grow, Grid} from '@material-ui/core';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Moment from 'moment'
import Badge from '@mui/material/Badge';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import MyLink from '@mui/material/Link';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Button from '@mui/material/Button';
import ChartsEmbedSDK from "@mongodb-js/charts-embed-dom";
import Card from '@mui/material/Card';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import { mainListItems, secondaryListItems } from '../listItems';

import LineChart from '../lineChart';
import UserList from '../userList';
import Odors from '../odorTracker';
import MapDevice from '../mapDevice';
//import LeafMap from '../leafMap';
import Legend from '../Legend';
import logo from '../logos/JustAirLogo1.png'

import { MapContainer, TileLayer, Marker, Popup, CircleMarker, Map, MapControl } from 'react-leaflet'
import 'leaflet/dist/leaflet.css'
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

import {useDispatch, useSelector} from 'react-redux'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useNavigate
} from "react-router-dom";

//import memories from './memories.png'
import { logout, reset } from '../features/auth/authSlice'
import {getProjects,getProject} from '../features/projects/projectSlice'
import {getMapDevices} from '../features/devices/deviceSlice'



//import memories from './memories.png'

import useStyles from '../styles'

const theme = createTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#29ABE2',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      light: '#0066ff',
      main: '#0044ff',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#ffcc00',
    },
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
  },
});


const Project = () => {

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { user } = useSelector((state) => state.auth)
  const { projects } = useSelector((state) => state.project)
  const { project } = useSelector((state) => state.project)
    const { mapDevices } = useSelector((state) => state.device)



   useEffect(() => {


     if (!user) {
       navigate('/login')
     }



     dispatch(getProjects())


     return () => {
       dispatch(reset())
     }
   }, [user, navigate])



    const onLogout = () => {
      dispatch(logout())
      dispatch(reset())
      navigate('/')

    }


function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <MyLink color="inherit" href="https://justair.co/" target="_blank">
        JustAir Solutions
      </MyLink>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    '& .MuiDrawer-paper': {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(9),
        },
      }),
    },
  }),
);

const mdTheme = createTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#1572A1',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      light: '#0066ff',
      main: '#0044ff',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#ffcc00',
    },
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
  },
});;


  const [open, setOpen] = React.useState(false);
  const toggleDrawer = () => {
    setOpen(!open);
  };

  var colorMarker = function (p){


    if (p>200.0){
      return { color: 'purple' };
    } else if (p>=151.0){
      return { color: 'red' };
    }else if (p>=101.0){
      return { color: 'orange' };
    }else if (p>=51.0){
      return { color: 'yellow' };
    }else{
      return { color: '#22b573' };
    }
  }


  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <AppBar position="absolute" open={open}>
          <Toolbar
            sx={{
              pr: '24px', // keep right padding when drawer closed
            }}
          >
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={toggleDrawer}
              sx={{
                marginRight: '36px',
                ...(open && { display: 'none' }),
              }}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              component="h1"
              variant="h6"
              color="white"
              noWrap
              sx={{ flexGrow: 1 }}
            >
              RAACE Air
            </Typography>

            {user ? (<>
            <Button color="inherit"   onClick={() => { onLogout()}}>Logout</Button></>
              ) :
              (<>
              <Button color="inherit"   onClick={() => { navigate("/login");}}>Login</Button>
              <Button color="inherit"  onClick={() => { navigate("/register");}}>Register</Button> </>)
            }


          </Toolbar>
        </AppBar>
        <Drawer variant="permanent" open={open}>
          <Toolbar
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              px: [1],
            }}
          >
            <IconButton onClick={toggleDrawer}>
              <ChevronLeftIcon />
            </IconButton>
          </Toolbar>
          <Divider />
          <List>{mainListItems}</List>
          <Divider />

        </Drawer>
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === 'light'
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
          }}
        >

          <Toolbar />





            <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>

                <Grid container  alignItems="center"
    justifyContent="center" spacing={2} xs={12} md={12} lg={12}  >
    <Grid item xs={12} >

    <h1>{project.projectName && project.projectName}</h1>

                  </Grid>


                  <Grid item sx={{ m: 1 }} xs={4} md={4} lg={4}>
                    <Card  sx={{ height:1 ,padding: 2}}>
                       <CardContent sx={{ height:'100%' }}>
                         <Typography sx={{ fontSize: 36 }}  gutterBottom>
                        {project.orgName && project.orgName}
                         </Typography>
                         <Typography variant="h5" component="div">
                          Project: {project.projectDescription && project.projectDescription}
                         </Typography>
                         <Typography variant="h5" component="div">
                           Project Description: {project.projectDescription && project.projectDescription}
                         </Typography>



                       </CardContent>

                     </Card>
                  </Grid>
                  <Grid item sx={{ m: 1 }} xs={4} md={4} lg={4}>
                    <Card  sx={{ height:1 ,padding: 2}}>
                       <CardContent sx={{ height:'100%' }}>
                         <Typography sx={{ fontSize: 40 }}  gutterBottom>
                        Devices
                         </Typography>
                           {project.devices && project.devices.map( ( dev ) => (
                         <Typography key={dev} variant="h5" component="div">
                         {dev}
                         </Typography>

                             ))}

                       </CardContent>

                     </Card>
                  </Grid>





<Grid item xs={12} md={12} lg={12}>
                  <Paper
                    sx={{
                      p: 2,
                      display: 'flex',
                      flexDirection: 'column',
                        height: 640
                    }}
                  >

                    {project.deviceProject&&
                        <MapContainer  style={{ height: "100%", width: "100%" }} center={[project.deviceProject[0].dataMeasures[0].latitude,project.deviceProject[0].dataMeasures[0].longitude]} zoom={13.5} scrollWheelZoom={false}>
                          <TileLayer
                            attribution="Map data &copy; <a href=&quot;https://www.openstreetmap.org/&quot;>OpenStreetMap</a> contributors, <a href=&quot;https://creativecommons.org/licenses/by-sa/2.0/&quot;>CC-BY-SA</a>, Imagery &copy; <a href=&quot;https://www.mapbox.com/&quot;>Mapbox</a>"
                            url="https://api.mapbox.com/styles/v1/darrenriley/ckwnd6rg801js15n7fqwqik78/tiles/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiZGFycmVucmlsZXkiLCJhIjoiY2t3bmQycnBpMGtuNjMwbzJxa2l0dmlvbyJ9.vbFNzKOFMTIVdZQrx4szgQ"
                          />
                          <Legend/>
                             {project.deviceProject && project.deviceProject.map( ( devData ) => (
                                <div key={devData.device_ID}>
                          {devData.dataMeasures && devData.dataMeasures.map( ( dev ) => (
                            <>
                            {dev.longitude &&
                            <CircleMarker center={[dev.latitude,[dev.longitude]]} pathOptions={colorMarker(dev.pollutants.voc.value)} radius={5}>
                              <Popup key={dev.date}>

                                     <b>Time:</b> {new Date(dev.date*1000).toLocaleString('en-US')} <br />
                                     <b> DeviceID:</b> {devData.device_ID}<br/>
                                     <b> VOC:</b> {dev.pollutants.voc.value}<br/>
                                     <b> NO2:</b> {dev.pollutants.no2.value}<br/>
                                     <b> PM2.5:</b> {dev.pollutants.pm25.value}<br/>



                               </Popup>
                            </CircleMarker>
                          }
                          </>
                          ))}
                          </div>
                          ))}



                        </MapContainer>
                            }


                  </Paper>
</Grid>




              </Grid>




              <Grid item xs={12}>
                <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                    <Copyright sx={{ pt: 4 }} />
                </Paper>
              </Grid>
                  </Container>
              </Box>
            </Box>



    </ThemeProvider>
  );



}


export default Project;
